import * as React from "react";
import { bindActionCreators, Dispatch } from "redux";
import { connect } from "react-redux";
import throttle from "lodash/throttle";

import { RootState } from "../../state";
import { ScreenSize, Breakpoints, BreakpointKeys } from "../utils/media";
import { screenSizeChanged } from "../actions/Media";

interface MappedProps {
  screenSize?: ScreenSize;
}

interface MappedActions {
  screenSizeChanged(size: ScreenSize): void;
}

type Props = MappedProps & MappedActions;

class ScreenSizeObserver extends React.Component<Props> {
  private onResizeThrottled: () => void;

  constructor(props: Props) {
    super(props);
    this.onResizeThrottled = throttle(this.onResize, 200);
  }

  public componentDidMount() {
    window.addEventListener("resize", this.onResizeThrottled);
    this.onResize();
  }

  public componentWillUnmount() {
    window.removeEventListener("resize", this.onResizeThrottled);
  }

  public onResize = () => {
    const windowWidth = window.innerWidth;
    const size = Object.entries(Breakpoints)
      .sort((a, b) => Breakpoints[a[0] as BreakpointKeys] - Breakpoints[b[0] as BreakpointKeys])
      .reduce(
        (acc, [key, size]) => {
          if (windowWidth >= size) {
            return key as ScreenSize;
          }
          return acc;
        },
        "small" as ScreenSize
      );
    if (size !== this.props.screenSize) {
      this.props.screenSizeChanged(size);
    }
  };

  public render() {
    return null;
  }
}

function mapStateToProps(state: RootState): MappedProps {
  const { screenSize } = state.media;
  return { screenSize };
}

function mapDispatchToProps(dispatch: Dispatch<RootState>): MappedActions {
  return bindActionCreators({ screenSizeChanged }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(ScreenSizeObserver);



// WEBPACK FOOTER //
// ./frontend/src/common/components/ScreenSizeObserver.tsx